export default "__VITE_ASSET__Ut3HtxYc__"